import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

import { assessLimits, getPositions } from '../utils/positionUtils';

const positionsSelector = createSelector(
  get('challenge.playerPositions'),
  get('challenge.players'),
  get('lineUp.selections'),
  () => 'PLAYER',
  getPositions
);

const teamPositionsSelector = createSelector(
  get('challenge.teamPositions'),
  get('challenge.teams'),
  get('lineUp.selections'),
  () => 'TEAM',
  getPositions
);

const playerPositionsSelector = createSelector(
  () => 'player',
  positionsSelector,
  teamPositionsSelector,
  get('challenge.playerQuota'),
  get('challenge.teamQuota'),
  get('challenge.shareQuota'),
  assessLimits
);

export default playerPositionsSelector;
